import React, { useEffect, useState } from 'react';
import './LandingPage.css'; // Reuse landing page styles for consistency

const CURRENCIES = ['$', '€', '£', '¥', '₹', '₿', 'Ξ', 'Ł', '₣', '₱', '₩', '₫', '₪', '₺', '₼', '₾', '₸', '₺', '₴', '₵', '₦', '₠', '₢', '₯', '₳', '₶', '₷', '₸', '₹', '円', '元', '₩', '₺', '₽', '₣', '₤', '₧'];

const LoadingScreen = () => {
    const [time, setTime] = useState(0);

    useEffect(() => {
        let frame;
        const animate = (t) => {
            setTime(t / 1000);
            frame = requestAnimationFrame(animate);
        };
        frame = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(frame);
    }, []);

    return (
        <div className="lp-loading-overlay" style={{ 
            position: 'fixed', 
            inset: 0, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            zIndex: 9000,
            overflow: 'hidden',
            backgroundColor: '#000000', // Solid dark blank background
        }}>
            <div className="lp-loader-card">
                <div className="lp-loader-flex">
                    <p>Loading</p>
                    <div className="lp-loader-words">
                        <span className="lp-loader-word">Transactions</span>
                        <span className="lp-loader-word">Dashboards</span>
                        <span className="lp-loader-word">Cards</span>
                        <span className="lp-loader-word">Split Groups</span>
                        <span className="lp-loader-word">Transactions</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingScreen;
